import React from 'react'
import { createAirlinesIndex, airlinesPredicate } from './airlines'
import { withStateHandlers } from 'recompose'
import { List, Set } from 'immutable'
import numeral from 'numeral'
import scrollToComponent from 'react-scroll-to-component';

/** A reference to the AirlinesFilter div. Used to scroll bottom of filters into view*/
let priceRangeRef = ''

/** Ui controls for a filter that matches offers based
 * on an all flights in a filter matching at least one
 * of the validating service prodiver (airline), unless none are selected,
 * in which case an option always matches.
 */
const AirlinesFilter = ({ offers = List(), airlineSelection, toggleAirlineOption }) => {
  const airlinesIndex = createAirlinesIndex(offers)

  return <div className="filter priceRange" ref={(elem)=>{priceRangeRef=elem}}>
      <h4>Airlines</h4>
      <ul className="priced" id="airline-rail_filter">
          <li>
            <label className="css-checkbox">
                <input
                    type="checkbox"
                    value="_ALL"
                    onChange={toggleAirlineOption}
                    checked={airlineSelection.includes("_ALL")} />
                <i/>
                <span className="text">All Airlines</span>
            </label>
          </li>
          {
            airlinesIndex.map((airlineInfo, airlineIdentifier) =>
              <li key={airlineIdentifier}>
                  <label className="css-checkbox">
                      <input
                          type="checkbox"
                          value={airlineIdentifier}
                          onChange={toggleAirlineOption}
                          checked={airlineSelection.includes(airlineIdentifier)} />
                      <i/>
                      <span className="text">
                        {airlineInfo.get('name')}
                      </span>
                      <span className="amount">
                                { numeral(airlineInfo.get('lowest',0)).format('0,0') }
                            </span>
                  </label>
              </li>
          ).valueSeq()
        }
      </ul>
  </div>
}

export default withStateHandlers(
    // Initial state
    ({offers}) => ({
        // To pre-select all options
        airlineSelection : Set(createAirlinesIndex(offers).keySeq()).add('_ALL'),
        airlinesIndex: createAirlinesIndex(offers)
    }),

    // State change handlers
    {
        /** Responds to stops checkbox tick/untick */
        toggleAirlineOption : ({airlineSelection, airlinesIndex},{onFilter}) => e => {
            const airlineIdentifier = e.target.value

            scrollToComponent(priceRangeRef, { offset: 50, align: 'bottom', duration: 200, ease:'linear'})
            if (airlineIdentifier === '_ALL')
            {
              if (e.target.checked)
              {
                const newAirlineSelection = airlinesIndex.reduce((set,v,k)=>set.add(k), Set()).add("_ALL")
                onFilter(airlinesPredicate(newAirlineSelection))
                return { airlineSelection : newAirlineSelection }
              } else {
                const newAirlineSelection = airlineSelection.clear()
                onFilter(airlinesPredicate(newAirlineSelection))
                return { airlineSelection : newAirlineSelection }
              }
            } else {
              const newAirlineSelection = e.target.checked
                  ? airlineSelection.add( airlineIdentifier )
                  : airlineSelection.remove( airlineIdentifier )

              // This option un-selects all flights upon no selection
              // console.log(newAirlineSelection.toString())
              onFilter(airlinesPredicate(newAirlineSelection))

              // New state
              return { airlineSelection : newAirlineSelection }
            }
        }
    }
)(AirlinesFilter)



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/airlines/AirlinesFilter.js